// Copyright (c) 2020 Deere & Company

import RgaMassUpdate from './rga-mass-update';
import RgaMassUpdateResultsRoutes from './rga-mass-update-results-routes';

export default {
    childRoutes: [
        RgaMassUpdate,
        RgaMassUpdateResultsRoutes
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/rga/mass-update')
    },
    name: 'Mass Update',
    path: 'mass'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-update-routes.js